import { render, staticRenderFns } from "./update-current-user-form.vue?vue&type=template&id=6c3e6033&scoped=true&lang=pug&"
import script from "./update-current-user-form.vue?vue&type=script&lang=ts&"
export * from "./update-current-user-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3e6033",
  null
  
)

export default component.exports